import {
    Dropdown,
    DropdownContent,
    DropdownItem,
    DropdownTrigger,
    FilterButton,
} from "@jhool-io/fe-components";
import { useMediaQuery } from "../../../../hooks/useMediaQuery";
import { truncateString } from "../../../../utils/helpers";
import {
    CLIENT_TAG_DETAILS,
    CLIENT_TAG_KEYS,
} from "../../helpers/clients.helpers";
import { ClientTagKey } from "../../types/clients.types";

const CLIENT_TAGS_PARAM = "tag_keys[]";

const isClientTagKey = (value: string): value is ClientTagKey =>
    CLIENT_TAG_KEYS.some((tagKey) => tagKey === value);

export function getClientTagsFilter(
    searchParams: URLSearchParams
): ClientTagKey[] {
    return searchParams.getAll(CLIENT_TAGS_PARAM).filter(isClientTagKey);
}

export function setClientTagsFilter(
    searchParams: URLSearchParams,
    tagKeys: ClientTagKey[]
) {
    searchParams.delete(CLIENT_TAGS_PARAM);
    tagKeys.forEach((tagKey) => searchParams.append(CLIENT_TAGS_PARAM, tagKey));
}

interface ClientTagsFilterProps {
    /** Selected client tag keys */
    values: ClientTagKey[];
    /** Called with the full list of selected client tag keys */
    onChange: (values: ClientTagKey[]) => void;
}

export default function ClientTagsFilter({
    values,
    onChange,
}: ClientTagsFilterProps) {
    const isSmallScreen = useMediaQuery("(max-width: 768px)");

    const getTriggerText = () => {
        if (values.length > 1) return `Tags (${values.length})`;
        return values[0]
            ? truncateString(CLIENT_TAG_DETAILS[values[0]].label, 16)
            : "Tags";
    };

    const handleOptionClick = (value: ClientTagKey) => {
        if (values.includes(value)) {
            onChange(values.filter((selectedValue) => selectedValue !== value));
            return;
        }
        onChange([...values, value]);
    };

    return (
        <Dropdown>
            <DropdownTrigger asChild>
                <FilterButton>{getTriggerText()}</FilterButton>
            </DropdownTrigger>
            <DropdownContent
                align={isSmallScreen ? "start" : "end"}
                width={isSmallScreen ? "250px" : "auto"}
                maxHeight={260}
            >
                {CLIENT_TAG_KEYS.map((tagKey) => (
                    <DropdownItem
                        key={tagKey}
                        onClick={() => handleOptionClick(tagKey)}
                        isMulti
                        itemValue={tagKey}
                        values={values}
                    >
                        <span className="normal-case">
                            {CLIENT_TAG_DETAILS[tagKey].label}
                        </span>
                    </DropdownItem>
                ))}
            </DropdownContent>
        </Dropdown>
    );
}
